module.exports = {"data":{"contentfulProject":{"title":"LOMEPAL — 50°","youtubeVideoUrl":"https://player.vimeo.com/video/791400916","production":"BON FILMS","date":"2022-11-11"}},"pathContext":{"id":"c1AKsYoeJUEyqDwfeH0zfDt","previousId":"c63hU3cS4UeDSI0PQeI5xFL","nextId":"wVIaWqg8R6SbrE2uJixJI"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt.json
// module chunks = 2034034880453577500